import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { DayOfWeekType } from 'lib/daysOfWeek'

const useCheckbox = (
  update: Dispatch<SetStateAction<string[] | DayOfWeekType[]>>,
  setIsEdited?: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement> | string) => {
      const id = typeof event === 'string' ? event : event.target.id

      update((prevState) => {
        // 選択済みの値であれば削除
        if (prevState.some((state) => state === id)) {
          return prevState.filter((state) => state !== id)
        } else {
          return [...prevState, id]
        }
      })
      setIsEdited && setIsEdited(true)
    },
    [update, setIsEdited]
  )
}

export default useCheckbox
